import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { selectToken } from '../../util/tokenSelector.js';
import { Floater } from '../FloatingUI/Floater.js';
import { ScreenReaderOnly } from '../ScreenReaderOnly/ScreenReaderOnly.js';
import { Typography } from '../Typography/Typography.js';
import { useThemeContext } from '../../contexts/session/Theme.js';

var _excluded = ["title", "content", "textAlign", "children", "usePortal", "hasInteractiveContent"];
/**
 * Tooltip displays additional information on hover or tap. Apart from title, content can be either text or list items.
 */
var Tooltip = /*#__PURE__*/React.memo(function (_ref) {
  var title = _ref.title,
    content = _ref.content,
    textAlign = _ref.textAlign,
    children = _ref.children,
    _ref$usePortal = _ref.usePortal,
    usePortal = _ref$usePortal === void 0 ? false : _ref$usePortal,
    hasInteractiveContent = _ref.hasInteractiveContent,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useThemeContext();
  var pointerColor = selectToken(theme.background, 'base.surface.floating.inverted');
  var pointerPadding = selectToken(theme.spacing, '8');
  var isList = content && typeof content !== 'string';
  var maxWidth = !isList ? '248px' : undefined;
  var role = 'tooltip';
  return /*#__PURE__*/React.createElement(Floater, _extends({
    visibleClass: "drone-tt-vis",
    interaction: "hover",
    useFlexWrapper: false,
    pointerColor: pointerColor,
    pointerPadding: pointerPadding,
    usePortal: usePortal,
    hasInteractiveContent: hasInteractiveContent,
    childrenContainerProps: {
      display: 'inline'
    },
    containerProps: {
      maxWidth: maxWidth,
      backgroundColor: 'base.surface.floating.inverted',
      borderRadius: '2',
      p: '12',
      role: 'tooltip'
    },
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScreenReaderOnly, null, role), title && /*#__PURE__*/React.createElement(Typography, {
      variant: "body-s-strong",
      textColor: "base.inverted",
      textAlign: isList ? undefined : textAlign
    }, title), content && (isList ? content : /*#__PURE__*/React.createElement(Typography, {
      variant: "body-s",
      textColor: "base.inverted",
      textAlign: isList ? undefined : textAlign,
      mt: title ? '4' : undefined
    }, content)))
  }, rest), children);
});
Tooltip.displayName = 'Tooltip';
Tooltip.defaultProps = {
  pointerPosition: 'start-below',
  textAlign: 'start',
  hasInteractiveContent: true
};

export { Tooltip };
//# sourceMappingURL=Tooltip.js.map
